import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';
import { URL_ROOT } from '../common/globalConstants.js';

const About = (props) => {

	const {
		history,
		locationId,
		title,
		description,
		textBlocks,
		allTextBlocks
	} = props;

	const [pageTextBlocks, setPageTextBlocks] = useState([]);

	useEffect(() => {

		if(allTextBlocks && allTextBlocks.length > 0) {
			if(textBlocks) {
				const currentTextBlocks = [];
				let matchingTextBlock = [];
				if(!Array.isArray(textBlocks)) {
					// eslint-disable-next-line
					matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks.Id);
					if(matchingTextBlock && matchingTextBlock.length === 1) {
						currentTextBlocks.push(matchingTextBlock[0]);
					}
				} else {
					for(let i = 0; i < textBlocks.length; i++) {
						// eslint-disable-next-line
						matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks[i].Id);
						if(matchingTextBlock && matchingTextBlock.length === 1) {
							currentTextBlocks.push(matchingTextBlock[0]);
						}
					}
				}

				setPageTextBlocks(currentTextBlocks);
			}
		} else {
			history.push(URL_ROOT);
		}
	// eslint-disable-next-line
	}, []);

	return (
		<React.Fragment>
			<MetaTags>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:title" content={title} />
			</MetaTags>
			<Header locationId={locationId} />
			<main>
				<div className='content'>
					<div className='pageContent'>
						<h1>{title}</h1>
						{pageTextBlocks.map(pageTextBlock => {
							if(pageTextBlock.IsHtml) {
								return <div key={pageTextBlock.id} className='bodyHtml' dangerouslySetInnerHTML={{__html: pageTextBlock.BodyText}} />;
							} else {
								return <p key={pageTextBlock.id} className='bodyText'>{pageTextBlock.BodyText}</p>;
								}
							})}
						</div>
					</div>
				</main>
				<Footer locationId={locationId} />
			</React.Fragment>
		);
	};

	const mapStateToProps = state => {
		return {
			allTextBlocks: state.application.textBlocks
		};
	};

	export default withRouter(connect(mapStateToProps, null)(About));
